import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
// import { updateExhibitor, getExhibitorById } from "api/exhibitor.api";
// import ExhibitorForm from "components/exhibitor/ExhibitorForm";
import Alert from "components/common/Alert";
import MasterCompanyForm from "components/masterCompanies/masterCompanyForm";
import {
  updateMasterCompany,
  getMasterCompanyById,
} from "api/masterCompany.api";
import Toast from "components/Toast";
export default function EditMasterCompany() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [initialData, setInitialData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState("");
  const [toast, setToast] = useState({
    open: false,
    title: "",
    message: "",
    type: "success",
  });

  useEffect(() => {
    fetchMasterCompany();
  }, []);

  const fetchMasterCompany = async () => {
    try {
      console.log("Fetching master company with ID:", id);
      const res = await getMasterCompanyById(id);
      setInitialData(res.data.data);
    } catch (err) {
      console.error("Fetch failed", err);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (formDataState) => {
    try {
      // 1. Create a FormData instance
    const payload = new FormData();

    // 2. Append all form keys to FormData
    Object.keys(formDataState).forEach((key) => {
      // Check if the property is a File object (uploaded new image)
      if (key === "masterCompanyLogo" && formDataState[key] instanceof File) {
        payload.append("masterCompanyLogo", formDataState[key]);
      } else if (formDataState[key] !== null && formDataState[key] !== undefined) {
        payload.append(key, formDataState[key]);
      }
    });

    // 3. Send the FormData instance
      await updateMasterCompany(id, payload);
      setToast({
        open: true,
        title: "Updated Successfully!",
        message: "Master company has been updated successfully.",
        type: "success",
      });
      //navigate("/admin/master");
    } catch (err) {
      console.error(err);
      setAlert(err.response?.data?.message || "Something went wrong");
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <>
      <MasterCompanyForm
        initialData={initialData}
        onSubmit={handleSubmit}
        onBack={() => navigate("/admin/master")}
        alert={alert}
        setAlert={setAlert}
      />
      <Toast
        open={toast.open}
        title={toast.title}
        message={toast.message}
        type={toast.type}
        duration={1000}
        onClose={() => {
          setToast((prev) => ({ ...prev, open: false }));
          // 3. Navigate after toast closes/timer finishes
          navigate("/admin/master");
        }}
      />
    </>
  );
}
